import SubAssignmentToProjectStore from './sub-assignment-to-project-store';
import SubOfProjectStore from './sub-of-project-store';
import * as SubcontractorActionType from './constants';
import * as UnitHelper from '../helper/unit-helper';
import {AppSettings} from '../constants';
import * as CommonActionType from '../Common/constants';

const defaultParams = {
  searchKey: '',
  skip: 1,
  take: 10,
  sort: { field: 'subcontractorName', order: 'ascending' },
  status: 'all',
  totalRecord: 0,
  totalPage: 0
};

const ManageSubcontractor = {
  items: [],
  params: defaultParams
};

const SuperAdminProfile = {
  userId: '',
  email: '',
  firstName: '',
  lastName: '',
  fullName: '',
  clientName: '',
  userStatus: -1,
  streetAddress: '',
  UserStatusValue: ''
};

const SubcontractorProfile = {
  id: '',
  trades: '',
  subcontractorId: '',
  subcontractorName: '',
  subcontractorEmail: '',
  subcontractorPhone: '',
  ownerEmail: '',
  clientStatus: AppSettings.CLIENT_STATUS.ACTIVE,
  clientStatusValue: '',
  isLocally: false
};

const InviteSubcontractor = {
  IsHiddenSearchEmail: false,
  IsHiddenSystemSubcontractor: true,
  IsHiddenNonSystemSubcontractor: true
};

const SubcontractorState = {
  ManageSubcontractor: ManageSubcontractor,
  InviteSubcontractor: InviteSubcontractor,
  SuperAdminProfile: SuperAdminProfile,
  SubcontractorProfile: SubcontractorProfile,
  SelectListItemTrade: [],
  ErrorMsg: [],
  IsBack: false,
  SubcontractorList: [],
  SubcontractorInformation: null,
  SuggestionOptions: []
};

function SubcontractorStore(state = SubcontractorState, action) {
  switch (action.type) {
    case CommonActionType.COMMON_SELECT_LIST_ITEM_TRADE_SUCCESS:
      return processSelectListItemTrade(state, action);
    case SubcontractorActionType.GET_SUBCONTRACTOR_BY_EMAIL_SUCCESS:
      return processInvite(state, action);
    case SubcontractorActionType.INVITE_SUBCONTRACTOR_ADMIN_SUCCESS:
      return {
        ...state,
        IsBack: true
      };
    case SubcontractorActionType.ADD_EDIT_SUBCONTRACTOR_ERROR:
      return {
        ...state,
        ErrorMsg: [action.data.error]
      };
    case SubcontractorActionType.ADD_SUBCONTRACTOR_ASYNC:
      return {
        ...state,
        ErrorMsg: []
      };
    case SubcontractorActionType.ADD_SUBCONTRACTOR_SUCCESS:
      return {
        ...state,
        IsBack: true
      };
    case SubcontractorActionType.SUBCONTRACTOR_ASSIGNMENT_ERROR:
      PubSub.publish(SubcontractorActionType.SUBCONTRACTOR_ASSIGNMENT_ERROR, { msg: action.data });
      return state;
    case SubcontractorActionType.GET_SUBCONTRACTOR_BY_NAME_SUCCESS:
      return {
        ...state,
        SubcontractorProfile: action.data
      };
    case SubcontractorActionType.SEARCH_SUBCONTRACTOR_SUCCESS:
      return processSearch(state, action);
    case SubcontractorActionType.RESET_SUBCONTRACTOR:
      return {
        ...state,
        ManageSubcontractor: ManageSubcontractor,
        SelectListItemTrade: [],
        ErrorMsg: [],
        InviteSubcontractor: {
          IsHiddenSearchEmail: false,
          IsHiddenSystemSubcontractor: true,
          IsHiddenNonSystemSubcontractor: true
        },
        SubcontractorProfile: SubcontractorProfile,
        IsBack: false
      };
    case SubcontractorActionType.RESET_INVITE_SUBCONTRACTOR_ADMIN:
      return processResetInvite(state, action);
    case SubcontractorActionType.SELECT_LIST_SUBCONTRACTOR_SUCCESS:
      return {
        ...state,
        SubcontractorList: action.data
      };
    case SubcontractorActionType.GET_SUBCONTRACTOR_BY_ID_SUCCESS:
      return {
        ...state,
        SubcontractorInformation: action.data
      };
    case SubcontractorActionType.GET_SUBCONTRACTOR_SUGGESTION_SUCCESS:
      return {
        ...state,
        SuggestionOptions: action.data
      };
    default:
      return state;
  }
}

const processInvite = (state, action) => {

  var result = action.data.item === null ? SuperAdminProfile : action.data.item;

  var inviteSubcontractor = {
    IsHiddenSearchEmail: false,
    IsHiddenSystemSubcontractor: true,
    IsHiddenNonSystemSubcontractor: true
  };

  if (!UnitHelper.isEmpty(result.userId)) {
    inviteSubcontractor.IsHiddenSearchEmail = true;
    inviteSubcontractor.IsHiddenSystemSubcontractor = false;
  } else {
    result.email = action.data.searchEmail;
    inviteSubcontractor.IsHiddenSearchEmail = true;
    inviteSubcontractor.IsHiddenNonSystemSubcontractor = false;
  }

  return {
    ...state,
    SuperAdminProfile: result,
    InviteSubcontractor: inviteSubcontractor
  };
};

const processSelectListItemTrade = (state, action) => {
  return {
    ...state,
    SelectListItemTrade: action.data
  };
};

const processSearch = (state, action) => {
  var result = action.data;
  var manageSubcontractor = {
    items: result.data.items,
    params: {
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage,
      skip: result.params.skip + 1,
      take: result.params.take,
      status: result.params.status,
      clientName: result.params.clientName,
      sort: { field: result.params.sortField, order: result.params.sortOrder }
    }
  };
  return {
    ...state,
    ManageSubcontractor: manageSubcontractor,
    SelectListItemTrade: [],
    ErrorMsg: [],
    IsBack: false
  };
};

const processResetInvite = (state) => {
  return {
    ...state,
    InviteSubcontractor: {
      IsHiddenSearchEmail: false,
      IsHiddenSystemSubcontractor: true,
      IsHiddenNonSystemSubcontractor: true
    }
  };
};
export { SubcontractorStore, SubAssignmentToProjectStore, SubOfProjectStore };



// WEBPACK FOOTER //
// ./src/Subcontractors/reducers.js